import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "sonner"

import LernpfadDemo from "@/app/demo/lernpfad/lernpfad-demo"
import "./index.css"

const queryClient = new QueryClient()

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <LernpfadDemo />
            <Toaster richColors position="top-right" />
        </QueryClientProvider>
    </StrictMode>,
)
